import { useEffect } from 'react';

/**
 * Prevents mouse-wheel scrolling from silently changing a focused `<input type="number">`.
 *
 * Browser number inputs decrement/increment by their `step` on wheel when focused, so scrolling
 * the form after typing a value (e.g. a stop-loss/target of `1`) silently drifts it to `0.99`,
 * `0.98`, ... by `step` each tick — with no save involved. Blurring the focused number input on
 * wheel lets the page scroll normally while leaving the typed value untouched.
 *
 * Mounted once per form; the listener is passive and only acts when a number input has focus.
 */
export function useNumberInputWheelGuard(): void {
  useEffect(() => {
    const handler = () => {
      const active = document.activeElement as HTMLInputElement | null;
      if (active && active.tagName === 'INPUT' && active.type === 'number') {
        active.blur();
      }
    };
    document.addEventListener('wheel', handler, { passive: true });
    return () => document.removeEventListener('wheel', handler);
  }, []);
}
